(() => {
  'use strict';
  document.querySelectorAll('[data-keepsake]').forEach(root => {
    const config = JSON.parse(root.querySelector('[data-page-config]').textContent);
    const form = root.querySelector('form[data-personalize]');
    const mainImage = root.querySelector('[data-main-image]');
    const thumbs = [...root.querySelectorAll('[data-gallery-index]')];
    let galleryIndex = 0;
    function showImage(index) {
      if (!mainImage || !thumbs.length) return;
      galleryIndex = (index + thumbs.length) % thumbs.length;
      const button = thumbs[galleryIndex];
      mainImage.src = button.dataset.image;
      mainImage.alt = button.dataset.alt;
      thumbs.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===galleryIndex)));
      const counter=root.querySelector('[data-gallery-count]');
      if(counter)counter.textContent=`${galleryIndex+1} / ${thumbs.length}`;
    }
    thumbs.forEach((b,i)=>b.addEventListener('click',()=>showImage(i)));
    root.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>showImage(galleryIndex-1));
    root.querySelector('[data-gallery-next]')?.addEventListener('click',()=>showImage(galleryIndex+1));
    if(!form)return;
    const review=root.querySelector('[data-order-review]');
    const engraving=root.querySelector('[data-engraving]');
    const engravingWrap=root.querySelector('[data-engraving-wrap]');
    const priceNodes=root.querySelectorAll('[data-price]');
    const variantInput=form.querySelector('[name="id"]');
    const submitButton=form.querySelector('[data-cart-submit]');
    const fileState=new Map();
    let activeVariant=null;
    function selectedValues(){
      const result={};
      form.querySelectorAll('[data-option-name]').forEach(el=>{
        if(el.type==='radio'&&!el.checked)return;
        result[el.dataset.optionName]=el.value;
      });
      return result;
    }
    function sync(){
      const values=selectedValues();
      if(engraving){
        const enabled=values['Engraving option']==='With engraving';
        engraving.disabled=!enabled; engraving.required=enabled;
        engravingWrap.hidden=!enabled;
      }
      const color=values['Frame finish'];
      if(color&&config.finishImages?.[color]!==undefined){
        const previous=root.dataset.activeFinish;
        if(previous!==color){showImage(config.finishImages[color]);root.dataset.activeFinish=color;}
      }
      const style=values['Design style'];
      if(style&&config.styleImages?.[style]!==undefined&&root.dataset.activeStyle!==style){
        showImage(config.styleImages[style]);root.dataset.activeStyle=style;
      }
      activeVariant=(config.variants||[]).find(v=>Object.entries(v.options).every(([k,val])=>values[k]===val));
      if(activeVariant?.image && root.dataset.activeVariantImage!==activeVariant.image){
        mainImage.src=activeVariant.image;
        root.dataset.activeVariantImage=activeVariant.image;
      }
      if(variantInput)variantInput.value=activeVariant?.id||'';
      const pending=config.pricePending || !activeVariant || activeVariant.price==null;
      const label=pending?'Price under review':new Intl.NumberFormat('en-US',{style:'currency',currency:config.currency||'USD'}).format(activeVariant.price)+' '+(config.currency||'USD');
      priceNodes.forEach(el=>{el.textContent=label;el.classList.toggle('pending',pending);});
      const selectionNote=root.querySelector('[data-selection-note]');
      if(selectionNote&&values.Size)selectionNote.textContent=values.Size+' diameter selected · Price changes with size';
      const styleNote=root.querySelector('[data-style-note]');
      if(styleNote)styleNote.textContent=config.styleNotes?.[values['Design style']]||'';
      if(submitButton)submitButton.disabled=config.mode!=='shopify'||pending||!activeVariant?.available;
      if(review)review.hidden=true;
    }
    form.addEventListener('change',sync);
    form.addEventListener('input',()=>{if(review)review.hidden=true;});
    form.querySelectorAll('input[type="file"]').forEach(input=>{
      const wrap=input.closest('.upload');
      const preview=wrap.querySelector('[data-photo-preview]');
      const error=wrap.querySelector('[data-file-error]');
      const clear=wrap.querySelector('[data-clear-file]');
      function reset(){
        const previous=fileState.get(input);if(previous)URL.revokeObjectURL(previous);
        fileState.delete(input);input.setCustomValidity('');
        if(preview){preview.removeAttribute('src');preview.hidden=true;}
        if(error){error.textContent='';error.hidden=true;}
        if(clear)clear.hidden=true;
      }
      input.addEventListener('change',()=>{
        reset();const file=input.files?.[0];if(!file)return;
        const validType=['image/jpeg','image/png','image/webp'].includes(file.type);
        const message=!validType?'Choose a JPG, PNG or WebP image.':file.size>10*1024*1024?'Choose an image smaller than 10 MB.':'';
        if(message){input.setCustomValidity(message);if(error){error.textContent=message;error.hidden=false;}return;}
        const url=URL.createObjectURL(file);fileState.set(input,url);
        if(preview){preview.src=url;preview.hidden=false;preview.onload=()=>input.setCustomValidity('');preview.onerror=()=>{input.setCustomValidity('This image could not be opened. Choose another image.');if(error){error.textContent='This image could not be opened. Choose another image.';error.hidden=false;}};}
        if(clear)clear.hidden=false;
      });
      clear?.addEventListener('click',()=>{input.value='';reset();if(review)review.hidden=true;});
    });
    function validate(){
      for(const input of form.querySelectorAll('[data-nonblank]')){
        input.setCustomValidity(!input.disabled&&input.required&&!input.value.trim()?'Enter the wording you would like us to use.':'');
      }
      return form.reportValidity();
    }
    form.querySelector('[data-review-button]')?.addEventListener('click',()=>{
      if(!validate())return;
      const values=selectedValues();
      const items=Object.entries(values);
      form.querySelectorAll('input[type="file"]').forEach(input=>items.push([input.dataset.reviewLabel,input.files[0].name]));
      if(engraving&&!engraving.disabled)items.push(['Engraving text',engraving.value.trim()]);
      const rugText=form.querySelector('[data-rug-text]');
      if(rugText)items.push(['Name or short text',rugText.value.trim()]);
      items.push(['Quantity',form.querySelector('[name="quantity"]').value]);
      items.push(['Price per item',config.pricePending?'Under review':root.querySelector('[data-price]')?.textContent||'Under review']);
      const quantity=Number(form.querySelector('[name="quantity"]').value);
      if(!config.pricePending&&activeVariant?.price!=null)items.push(['Items subtotal',new Intl.NumberFormat('en-US',{style:'currency',currency:config.currency||'USD'}).format(activeVariant.price*quantity)+' '+(config.currency||'USD')+' (before shipping and tax)']);
      const dl=review.querySelector('dl');dl.replaceChildren();
      items.forEach(([label,value])=>{const dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=label;dd.textContent=value;dl.append(dt,dd);});
      review.hidden=false;review.focus();
    });
    form.addEventListener('submit',event=>{
      if(config.mode!=='shopify'||config.pricePending||!activeVariant?.available||!validate())event.preventDefault();
    });
    window.addEventListener('pagehide',()=>fileState.forEach(url=>URL.revokeObjectURL(url)));
    sync();
  });
})();
